import React from 'react';
import PropTypes from 'prop-types';
import FlexContainer from '../FlexContainer/FlexContainer';
import LightningFilled from '../Icons/LightningFilled';
import Tooltip from '../Tooltip/Tooltip';
import {colors} from '../../utils/colors.js';

const ICON_STYLE = {flexShrink: 0, width: 13, height: 13, cursor: 'default'};
const TOOLTIP_ICON_STYLE = {display: 'flex', alignItems: 'center'};

// Same lightning bolt the guest saw on the guaranteed offer, so the sale reads the same on both sides
const GuaranteedUpgradeMarker = ({isGuaranteedUpgrade, justifyContent = 'center', children}) => {
  if (!isGuaranteedUpgrade) {
    return children;
  }

  return (
    <FlexContainer gap={6} alignItems="center" justifyContent={justifyContent}>
      <Tooltip content="Sold as a Guaranteed Upgrade" position="top" portal style={TOOLTIP_ICON_STYLE}>
        <LightningFilled color={colors.warning} style={ICON_STYLE} />
      </Tooltip>
      {children}
    </FlexContainer>
  );
};

GuaranteedUpgradeMarker.propTypes = {
  isGuaranteedUpgrade: PropTypes.bool,
  justifyContent: PropTypes.string,
  children: PropTypes.node.isRequired,
};

export default GuaranteedUpgradeMarker;
